import { render, staticRenderFns } from "./maDetails.vue?vue&type=template&id=3e2ab8cb&scoped=true"
import script from "./maDetails.vue?vue&type=script&lang=js"
export * from "./maDetails.vue?vue&type=script&lang=js"
import style0 from "./maDetails.vue?vue&type=style&index=0&id=3e2ab8cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ab8cb",
  null
  
)

export default component.exports